import css from '../../../../../utils/css';

const styles = css`
  *[class^='Theme_'] {
    --font-family: 'IBM Plex Sans', 'IBM Plex Sans Fallback';
    --joe-black: #132428;
    --joe-yellow: #ffc627;
    --joe-white: #fff;

    --primary-color: var(--joe-white);
    --offer-cta-color: var(--joe-black);
    --offer-cta-bg-color: var(--joe-yellow);
    --offer-cta-bg-color-hover: var(--joe-yellow);
  }

  *[class^='Text_'] {
    font-family: var(--secondary-font-family);
  }

  *[class^='Cta_'] > button {
    font-family: var(--primary-font-family-condensed);
    font-weight: bold;
  }
`;

export default styles;
